import AxiosClient from "../../../services/axios.services";

class ObjectiveCompetencyPillarServices {
  getObjectiveCompetencyPillar = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_competencias_pilar/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getObjectiveCompetencyPillarById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_competencias_pilar/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveObjectiveCompetencyPillar = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_competencias_pilar/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editObjectiveCompetencyPillar = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_competencias_pilar/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteObjectiveCompetencyPillar = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_competencias_pilar/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new ObjectiveCompetencyPillarServices();
